import { DOCTYPES } from '@/constants/doctypes'
import { createDoctypeRoutes } from '@/routers/routes/createDoctypeRoutes'

const {
  create: routeSupplierGroupCreate,
  detail: routeSupplierGroupDetail,
  home: routeSupplierGroupSettingsHome,
  root: routeSupplierGroupSettingsRoot,
} = createDoctypeRoutes({
  createName: 'new-supplier-group',
  createPath: 'new-supplier-group',
  detailName: 'supplier-group-detail',
  doctype: DOCTYPES.SUPPLIER_GROUP,
  homeName: 'supplier-group-settings-home',
  path: 'supplier-group',
  views: {
    create: async () =>
      await import('@/components/viewsExternal/supplierGroup/AddSupplierGroup.vue'),
    detail: async () =>
      await import('@/components/viewsExternal/supplierGroup/ViewSupplierGroup.vue'),
    list: async () => await import('@/components/viewsExternal/settings/brm/ViewBRMSettings.vue'),
  },
})

export {
  routeSupplierGroupCreate,
  routeSupplierGroupDetail,
  routeSupplierGroupSettingsHome,
  routeSupplierGroupSettingsRoot,
}
